import { useFetcher, useParams } from "react-router-dom";
import { Mui, MuiIcons } from "@osu/react-ui";
import { useSelector } from "react-redux";
import useFetcherHashKey from "../hooks/useFetcherHash";
import { forwardRef, Fragment, useRef } from "react";
import {
  selectActionsToAllow
} from "../../services/form/slices";
import FormLoader from "../Loaders/components/Form";
import useReadOnlyMode from "../hooks/useReadOnlyMode";
import NextWidget from "./Router/NextWidget";
import ChangeStatus from "./Admin/ChangeStatus";

export const formStyles = (theme, loading) => {
  const styles = {
    [`button[type="submit"]`]: {
      display: "flex",
    },
    [`& > *, & > .${Mui.formControlClasses.root}`]: {
      marginBottom: theme.spacing(3),
    },
    [` .${Mui.formLabelClasses.root}, .${Mui.formHelperTextClasses.root}`]: {
      color: theme.palette.text.default,
    },
  };
  if(loading) {
    styles.display = "none"
  }
  return styles
};

const equalitySelector = (a, b) => {
  const entries = (obj) => Object.entries(obj).map(([key, value]) => {
    return `${key}:${value}`
  }).join("#")

  if(!Object.keys(a)?.length && !Object.keys(b)?.length) {
    return true
  }
  const isMatch = entries(a) === entries(b)

  return isMatch
}

const HTMLForm = forwardRef((props, ref) => {
  const { children, onSave, onDelete, onSubmit, onSubmitClick, loading }  = props
  const { id, type: formType } = useParams();
  const hash = useFetcherHashKey();
  const fetcher = useFetcher({ key: hash });
  const { readOnly } = useReadOnlyMode()
  const saveRef = useRef()
  const { actionable, showStandardSubmitButton, showAcceptButton, showSaveButton, showDeleteButton } = useSelector(
    (state) =>
      selectActionsToAllow(state, {
        id,
        formType,
      }),
      equalitySelector
  );
  const disabled = readOnly
    
  return (
    <Fragment>
      {loading && <FormLoader />}
      <Mui.Paper elevation={1} sx={{ p: 3, mb: 4 }}>
      <Mui.Box
        ref={ref}
        sx={theme => formStyles(theme, loading)}
        component={fetcher.Form}
        method="post"
        onSubmit={onSubmit}
      >
        {children}
        <Mui.Box component="section">
          <Mui.Typography component="h2" variant="srOnly">
            Form Actions
          </Mui.Typography>
          {actionable && <Mui.Divider sx={{ marginBottom: 2 }} />}
          <Mui.Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
              {(showAcceptButton || showStandardSubmitButton) && (
                <Mui.Button
                  sx={{
                    marginLeft: 2,
                  }}
                  variant="contained"
                  type="submit"
                  color="primary"
                  onClick={onSubmitClick}
                  disabled={disabled}
                  endIcon={<MuiIcons.Send />}
                >
                  {showAcceptButton ? "Reported" : "Submit"}
                </Mui.Button>
              )}
              {showSaveButton && (
                <Mui.Button
                  sx={{
                    marginLeft: 2,
                  }}
                  onClick={onSave}
                  variant="outlined"
                  color="primary"
                  ref={saveRef}
                  disabled={disabled}
                  endIcon={<MuiIcons.Save />}
                >
                  Save
                </Mui.Button>
              )}
              <NextWidget 
                  variant="outlined"
                  color="primary" 
                  sx={{
                    marginLeft: 2,
                  }}
                />
              <ChangeStatus 
                  variant="outlined"
                  color="primary"  />
              {showDeleteButton && (
                <Mui.Button
                  onClick={onDelete}
                  color="error"
                  sx={{
                    marginRight: "auto",
                  }}
                  variant="outlined"
                  disabled={disabled}
                  endIcon={<MuiIcons.Delete />}
                >
                  Delete
                </Mui.Button>
              )}
            </Mui.Box>
        </Mui.Box>
      </Mui.Box>
      </Mui.Paper>
    </Fragment>
  );
})

export default HTMLForm;
